import { connect } from 'react-redux';
import UsersList from './UsersList';

const mapStateToProps = state => ({
    user: state.auth && state.auth.user,
});

export default connect(mapStateToProps)(UsersList);
